import { Component, OnInit, ElementRef } from '@angular/core';
import {  ViewChild } from '@angular/core';

declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";


import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes} from '@angular/router';
import {Http, Response, Headers} from '@angular/http';

@Component({
  selector: 'app-fe-glenn',
  templateUrl: './fe-glenn.component.html',
  styleUrls: ['./fe-glenn.component.css']
})
export class FeGlennComponent implements OnInit {

  totalroomevents:RoomEvents[];
  roomevents_arena:RoomEvents[];
  roomevents_CommroomA:RoomEvents[];
  roomevents_CommroomB:RoomEvents[];
  roomevents_CommroomC:RoomEvents[];
  roomevents_Gym:RoomEvents[];

  public event_array_arena:Event_array_arena[];
  public event_CommroomA:Event_array_room[];
  public event_CommroomB:Event_array_room[];
  public event_CommroomC:Event_array_room[];
  public event_Gym:Event_array_room[];

  public Event_start_time:string[];
  public Event_end_time:string[];
  public Today_date:string;
  public Clock_date:string;

  public Event_room_name:string;
  
  public event_counter_arena:number;
  public event_counter_room:number;

  constructor(private route: ActivatedRoute,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) {
    setInterval(() => {
       this.refreshData();
    }, 15000);
  

    $("#slideshow > div:gt(0)").hide();

    setInterval(() => { 
      $('#slideshow > div:first')
        .fadeOut(1000)
        .next()
        .fadeIn(1000)
        .end()
        .appendTo('#slideshow');
    },  7000);


   }

  ngOnInit() {
    this.event_counter_arena=0;
    this.event_counter_room=0;
    $("#slideshow > div:gt(0)").hide();
    this.refreshData();
  }

  format_time= (date_obj) => {
    // formats a javascript Date object into a 12h AM/PM time string
    var hour = date_obj.getHours();
    var minute = date_obj.getMinutes();
    var amPM = (hour > 11) ? "PM" : "AM";
    if(hour > 12) {
      hour -= 12;
    } else if(hour == 0) {
      hour = "12";
    }
    if(minute < 10) {
      minute = "0" + minute;
    }
    return hour + ":" + minute +" "+ amPM;
   }


   refreshData = ()=>{
    console.log("getting data")
      let account_id = this.route.snapshot.paramMap.get('id');
      console.log(account_id)
       ////Date////
       var d = new Date();
       var currentDate = d.getTime();
       var currentDate_start = d.setHours(0);
       var currentDate_start = d.setMinutes(0);
       var currentDate_start = d.setSeconds(0);
       var currentDate_end = d.setHours(23);
       var currentDate_end = d.setMinutes(59);
       var currentDate_end = d.setSeconds(59);
    


       this.getdataService.getEventsByAccountID(account_id).subscribe((roomevents) => {
         console.log(roomevents)
        this.totalroomevents=  roomevents;
        this.roomevents_CommroomA = [];
        this.roomevents_CommroomB = [];
        this.roomevents_CommroomC = [];
        this.roomevents_Gym = [];
        this.roomevents_arena = [];
        ////console.log(roomevents)
        var x=0;
        var y=0;
        var z=0;
        var c=0;
        var m=0;

        //separate arrays//
        
        for(let i=0; i<this.totalroomevents.length; i++)
        {
          let startDate = new Date(this.totalroomevents[i].event_start_time).getTime() + (d.getTimezoneOffset() * 60000);
          let endDate = new Date(this.totalroomevents[i].event_end_time).getTime() + (d.getTimezoneOffset() * 60000);
          if(startDate>currentDate_start && endDate<currentDate_end && endDate>currentDate)
          {
           if(this.totalroomevents[i].event_room =='Community Center - Room A')
           {
             console.log("added to Community Center - Room A")
            this.roomevents_CommroomA.push(this.totalroomevents[i]);
           }else if(this.totalroomevents[i].event_room =='Community Center - Room B'){
            console.log("added to Community Center - Room B")
            this.roomevents_CommroomB.push(this.totalroomevents[i]);
           }else if(this.totalroomevents[i].event_room =='Community Center - Room C'){
            console.log("added to Community Center - Room C")
            this.roomevents_CommroomC.push(this.totalroomevents[i]);
           }else if(this.totalroomevents[i].event_room =='Gymnasium'){
            console.log("added to Gymnasium")
            this.roomevents_Gym.push(this.totalroomevents[i]);
           }else{
            this.roomevents_arena.push(this.totalroomevents[i]);
           }
          }
        }
        
        this.event_array_arena=[];
        this.roomevents_arena = this.sortByKey(this.roomevents_arena,'event_start_time');

        for(let i=this.event_counter_arena; i<this.roomevents_arena.length; i++)
         {
           var startDate = new Date(this.roomevents_arena[i].event_start_time).getTime() + (d.getTimezoneOffset() * 60000);
           var endDate = new Date(this.roomevents_arena[i].event_end_time).getTime() + (d.getTimezoneOffset() * 60000);

           if(startDate>currentDate_start && endDate<currentDate_end && endDate>currentDate)
           {
    
             this.event_array_arena[x]={Event_id:x,Event_name:'',Event_room:'',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:''}
             this.event_array_arena[x].Event_name=this.roomevents_arena[i].event_name ;
             this.event_array_arena[x].Event_room=this.roomevents_arena[i].event_host_name ;
              var  date = new Date(startDate);
             this.event_array_arena[x].Event_start_time=this.format_time(date).toString();
             this.event_array_arena[x].Event_start_time_number = startDate;
             date = new Date(endDate);
             this.event_array_arena[x].Event_end_time=this.format_time(date).toString() ;
             this.event_array_arena[x].Event_end_time_number = endDate;
             this.event_array_arena[x].Event_Host_Name=this.roomevents_arena[i].event_room;
             
             x++;
            
           }
          
         }
        
        //   this.event_counter_arena=this.event_counter_arena+7;
        //  //console.log("counter ",this.event_counter_arena);
        //  //console.log("length ",this.roomevents_arena.length);
        //  if(this.event_counter_arena >= this.event_array_arena.length)
        //  {
        //   this.event_counter_arena=0;
        //  }


   //////////////////////////////////////shooter pads/////////////////////////////////////////////////
         this.event_CommroomA=[];
         this.roomevents_CommroomA = this.sortByKey(this.roomevents_CommroomA,'event_start_time');

         for(let i=this.event_counter_room; i<this.roomevents_CommroomA.length; i++)
         {
           var startDate = new Date(this.roomevents_CommroomA[i].event_start_time).getTime() + (d.getTimezoneOffset() * 60000);
           var endDate = new Date(this.roomevents_CommroomA[i].event_end_time).getTime() + (d.getTimezoneOffset() * 60000);
           ////console.log("start date of the event in general:");
          ////console.log("Check_Start Date: "+startDate);
          ////console.log("Check_currentDate: "+currentDate);

          if(startDate>currentDate_start && endDate<currentDate_end && endDate>currentDate)
          {
            console.log("counting valid events")
            /////event name/////
            console.log("event name");
            console.log(this.roomevents_CommroomA[i].event_name);
            ////console.log(y);
            this.event_CommroomA[y]={Event_id:y,Event_name:'',Event_room:'',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:''}
            this.event_CommroomA[y].Event_name=this.roomevents_CommroomA[i].event_name ;
            this.event_CommroomA[y].Event_room=this.roomevents_CommroomA[i].event_room ;
              var  date = new Date(startDate);
            this.event_CommroomA[y].Event_start_time=this.format_time(date).toString();
            this.event_CommroomA[y].Event_start_time_number = startDate;
            date = new Date(endDate);
            this.event_CommroomA[y].Event_end_time=this.format_time(date).toString() ;
            this.event_CommroomA[y].Event_end_time_number = endDate;
            ////console.log(this.event_array_room[y].Event_end_time);
            this.event_CommroomA[y].Event_Host_Name=this.roomevents_CommroomA[i].event_host_name;
            
            y++;
            //////current meeting fetch////////
            
          }
        }


        
        this.event_CommroomA = this.sortByKey(this.event_CommroomA,'Event_start_time_number');


        this.event_CommroomB=[];
        this.roomevents_CommroomB = this.sortByKey(this.roomevents_CommroomB,'event_start_time');

        for(let i=this.event_counter_room; i<this.roomevents_CommroomB.length; i++)
        {
          var startDate = new Date(this.roomevents_CommroomB[i].event_start_time).getTime() + (d.getTimezoneOffset() * 60000);
          var endDate = new Date(this.roomevents_CommroomB[i].event_end_time).getTime() + (d.getTimezoneOffset() * 60000);
          ////console.log("start date of the event in general:");
         ////console.log("Check_Start Date: "+startDate);
         ////console.log("Check_currentDate: "+currentDate);

         if(startDate>currentDate_start && endDate<currentDate_end && endDate>currentDate)
         {
           console.log("counting valid events")
           /////event name/////
           console.log("event name");
           console.log(this.roomevents_CommroomB[i].event_name);
           ////console.log(y);
           this.event_CommroomB[z]={Event_id:z,Event_name:'',Event_room:'',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:''}
           this.event_CommroomB[z].Event_name=this.roomevents_CommroomB[i].event_name ;
           this.event_CommroomB[z].Event_room=this.roomevents_CommroomB[i].event_room ;
             var  date = new Date(startDate);
           this.event_CommroomB[z].Event_start_time=this.format_time(date).toString();
           this.event_CommroomB[z].Event_start_time_number = startDate;
           date = new Date(endDate);
           this.event_CommroomB[z].Event_end_time=this.format_time(date).toString() ;
           this.event_CommroomB[z].Event_end_time_number = endDate;
           ////console.log(this.event_array_room[y].Event_end_time);
           this.event_CommroomB[z].Event_Host_Name=this.roomevents_CommroomB[i].event_host_name;
           
           z++;
           //////current meeting fetch////////
           
         }
       }
       this.event_CommroomB = this.sortByKey(this.event_CommroomB,'Event_start_time_number');
         
       
       //////////////////////////////////////community rooms/////////////////////////////////////////////////
       this.event_CommroomC=[];
       this.roomevents_CommroomC = this.sortByKey(this.roomevents_CommroomC,'event_start_time');

       for(let i=this.event_counter_room; i<this.roomevents_CommroomC.length; i++)
       {
         var startDate = new Date(this.roomevents_CommroomC[i].event_start_time).getTime() + (d.getTimezoneOffset() * 60000);
         var endDate = new Date(this.roomevents_CommroomC[i].event_end_time).getTime() + (d.getTimezoneOffset() * 60000);
         ////console.log("start date of the event in general:");
        ////console.log("Check_Start Date: "+startDate);
        ////console.log("Check_currentDate: "+currentDate);

        if(startDate>currentDate_start && endDate<currentDate_end && endDate>currentDate)
        {
          console.log("counting valid events")
          /////event name/////
          console.log("event name");
          console.log(this.roomevents_CommroomC[i].event_name);
          ////console.log(y);
          this.event_CommroomC[c]={Event_id:c,Event_name:'',Event_room:'',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:''}
          this.event_CommroomC[c].Event_name=this.roomevents_CommroomC[i].event_name ;
          this.event_CommroomC[c].Event_room=this.roomevents_CommroomC[i].event_room ;
            var  date = new Date(startDate);
          this.event_CommroomC[c].Event_start_time=this.format_time(date).toString();
          this.event_CommroomC[c].Event_start_time_number = startDate;
          date = new Date(endDate);
          this.event_CommroomC[c].Event_end_time=this.format_time(date).toString() ;
          this.event_CommroomC[c].Event_end_time_number = endDate;
          ////console.log(this.event_array_room[y].Event_end_time);
          this.event_CommroomC[c].Event_Host_Name=this.roomevents_CommroomC[i].event_host_name;
          
          c++;
          //////current meeting fetch////////
          
        }
      }


      
      this.event_CommroomC = this.sortByKey(this.event_CommroomC,'Event_start_time_number');


      this.event_Gym=[];
      this.roomevents_Gym = this.sortByKey(this.roomevents_Gym,'event_start_time');

      for(let i=this.event_counter_room; i<this.roomevents_Gym.length; i++)
      {
        var startDate = new Date(this.roomevents_Gym[i].event_start_time).getTime() + (d.getTimezoneOffset() * 60000);
        var endDate = new Date(this.roomevents_Gym[i].event_end_time).getTime() + (d.getTimezoneOffset() * 60000);
        ////console.log("start date of the event in general:");
       ////console.log("Check_Start Date: "+startDate);
       ////console.log("Check_currentDate: "+currentDate);

       if(startDate>currentDate_start && endDate<currentDate_end && endDate>currentDate)
       {
         console.log("counting valid events")
         /////event name/////
         console.log("event name");
         console.log(this.roomevents_Gym[i].event_name);
         ////console.log(y);
         this.event_Gym[m]={Event_id:m,Event_name:'',Event_room:'',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:''}
         this.event_Gym[m].Event_name=this.roomevents_Gym[i].event_name ;
         this.event_Gym[m].Event_room=this.roomevents_Gym[i].event_room ;
           var  date = new Date(startDate);
         this.event_Gym[m].Event_start_time=this.format_time(date).toString();
         this.event_Gym[m].Event_start_time_number = startDate;
         date = new Date(endDate);
         this.event_Gym[m].Event_end_time=this.format_time(date).toString() ;
         this.event_Gym[m].Event_end_time_number = endDate;
         ////console.log(this.event_array_room[y].Event_end_time);
         this.event_Gym[m].Event_Host_Name=this.roomevents_Gym[i].event_host_name;
         
         m++;
         //////current meeting fetch////////
         
       }
     }
     this.event_Gym = this.sortByKey(this.event_Gym,'Event_start_time_number');
       
       
       
       
       
       
       
       
       
       
       
       
      //  console.log(this.event_ShooterpadB.length)
      //    console.log(this.event_ShooterpadA);
    },
    err=>{
      //////console.log(err);
      return false;
    });
    
   }


   sortByKey(array, key) {
    return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}

}



interface RoomEvents{
  _id:number,
  event_name:string,
  event_room:string,
  event_room_id:string,
  event_place:string,
  event_start_time:Date,
  event_start_time_readable:string,
  event_end_time_readable:string,
  event_end_time:Date,
  event_logo:string,
  event_logo_path:string,
  event_host_name:string,
  event_attendants:string[]
}


interface Event_array_arena{
  Event_id:number,
  Event_name:string,
  Event_room:string,
  Event_start_time:string,
  Event_start_time_number:number,
  Event_end_time:string,
  Event_end_time_number:number,
  Event_Host_Name:string
}

interface Event_array_room{
  Event_id:number,
  Event_name:string,
  Event_room:string,
  Event_start_time:string,
  Event_start_time_number:number,
  Event_end_time:string,
  Event_end_time_number:number,
  Event_Host_Name:string
}


// WEBPACK FOOTER //
// ./src/app/components/fe-glenn/fe-glenn.component.ts